export const DEFAULT_MCP_ROUTE_PREFIX = "/mcp" as const;
export const DEFAULT_MCP_SSE_SEGMENT = "sse" as const;
export const DEFAULT_MCP_MESSAGES_SEGMENT = "messages" as const;
export const DEFAULT_MCP_HTTP_SEGMENT = "mcp" as const;
export const MCP_SESSION_QUERY_PARAM = "sessionId" as const;
